import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './effects.index';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers.index';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { UserDataGateway } from './user-data/gatewayy/user-data.gateway';

@NgModule({
  imports: [
    EffectsModule.forRoot([]),
    EffectsModule.forFeature(effects),
    StoreModule.forRoot({
      router: routerReducer,
    }),
    StoreModule.forFeature('boelsState', reducers),
    StoreRouterConnectingModule.forRoot(),
  ],
  providers: [UserDataGateway],
})
export class SharedStateModule {}
